import React from 'react';

const SprintHeader = ({ sprint, sprints = [], onSelectSprint, onEdit, onClose, className = '' }) => {
  if (!sprint) return null;

  const isActive = sprint.status === 'active';
  const isClosed = sprint.status === 'closed';

  const endDateLabel = () => {
    try {
      if (!sprint.endOn) return '';
      const d = new Date(sprint.endOn);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch (_e) {
      return '';
    }
  };

  const formatRange = (start, end) => {
    try {
      if (!end) return '';
      const s = start ? new Date(start) : null;
      const e = new Date(end);
      const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      return `${s ? fmt(s) : ''} ${s ? '–' : ''} ${fmt(e)}`.trim();
    } catch (_e) {
      return '';
    }
  };

  return (
    <div className={`bg-succession-bg-primary border-b border-succession-border ${className}`}>
      <div className="px-6 py-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <h1 className="text-xl font-semibold text-succession-text-primary">Sprint Name: {sprint.name}</h1>
              {isActive && (
                <span className="text-sm text-succession-text-secondary">Due {endDateLabel()}</span>
              )}
              {isClosed && (
                <span className="text-sm text-green-600 font-medium">✓ Completed</span>
              )}
            </div>
            {sprint.objectiveText && (
              <p className="text-succession-text-secondary mt-2 text-sm">{sprint.objectiveText}</p>
            )}
          </div>
          <div className="flex items-center gap-3">
            <select
              className="text-sm border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-1"
              value=""
              onChange={(e) => onSelectSprint && onSelectSprint(e.target.value)}
            >
              <option value="" disabled>View Master Plan or Sprint...</option>
              <option value="__MAP__">Master Action Plan</option>
              {sprints.map((sp) => {
                const range = formatRange(sp.startOn, sp.endOn);
                const label = range ? `${sp.name} — ${range}` : sp.name;
                return (
                  <option key={sp.id} value={sp.id}>{label}</option>
                );
              })}
            </select>
            {onEdit && !isClosed && (
              <button onClick={onEdit} className="text-succession-text-secondary hover:text-succession-text-primary text-sm px-3 py-1 rounded-md border border-succession-border">
                Edit
              </button>
            )}
            {onClose && isActive && (
              <button onClick={onClose} className="text-red-600 border-red-200 hover:bg-red-50 text-sm px-3 py-1 rounded-md border">
                Complete Sprint
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SprintHeader;


